<template>
  <div class="flex flex-row space-x-2 shrink items-center">
    <template v-if="labels.length > 0">
      <template v-if="labels.length <= visibleItems">
        <template v-for="label in labels">
          <v-chip
            :key="label.text"
            :small="!xsmall"
            :x-small="xsmall"
            close
            :color="label.color"
            @click:close="clickClose(label)"
            >
            {{ label.text }}
          </v-chip>
        </template>
      </template>
      <template v-else>
        <template v-for="index in [...Array(visibleItems).keys()]">
          <v-chip
            :key="index"
            :small="!xsmall"
            :x-small="xsmall"
            close
            :color="labels[index].color"
            @click:close="removeSelectedLabel(labels[index])"
            >
            {{ labels[index].text }}
          </v-chip>
        </template>
        <v-menu
          :close-on-content-click="false"
          bottom
          offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text outlined small v-on="on">
              <span>{{ labels.length - 2}} More...</span>
            </v-btn>
          </template>
          <div class="flex flex-col space-y-2 p-4">
            <template v-for="(label, index) in labels">
              <template v-if="index > visibleItems - 1">
                <v-chip
                  :key="index"
                  :small="!xsmall"
                  :x-small="xsmall"
                  close
                  :color="label.color"
                  @click:close="clickClose(label)"
                  >
                  {{ label.text }}
                </v-chip>
              </template>
            </template>
          </div>
        </v-menu>
      </template>
    </template>
    <template v-else>
      <span class="text-gray-500 text-xs">No label</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'LabelList',

  props: {
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    
    visibleItems: {
      type: Number,
      default: 3
    },
    
    xsmall: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clickClose(item) {
      this.$emit('click-close', item)
    }
  }
}
</script>